import { Switch, SwitchProps, styled } from '@mui/material';

const BasicSwitchWithStatus = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} checked={Boolean(props.checked)} />
))(({ theme, checked }) => ({
  width: checked ? 112 : 119,
  height: 44,
  padding: 2,
  '& .MuiSwitch-switchBase': {
    padding: 2,
    margin: 8,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(68px)',
      color: 'transparent',
      '& + .MuiSwitch-track': {
        backgroundColor: '#FFFFFF',
        opacity: 1,
        border: '1px solid #93D500',
        '&::before': {
          content: '"Active"',
          position: 'absolute',
          left: '12px',
          color: '#939393',
          lineHeight: '24px',
          fontSize: '16px',
        },
      },
      '& .MuiSwitch-thumb': {
        backgroundColor: '#93D500',
      },
    },
    '&:not(.Mui-checked)': {
      '& + .MuiSwitch-track': {
        backgroundColor: '#FFFFFF',
        opacity: 1,
        border: '1px solid #939393',
        '&::before': {
          content: '"Inactive"',
          position: 'absolute',
          right: '12px',
          color: '#939393',
          lineHeight: '24px',
          fontSize: '16px',
        },
      },
      '& .MuiSwitch-thumb': {
        backgroundColor: '#939393',
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: 'transparent',
      border: 'none',
      boxShadow: '0 0 0 6px rgba(0,0,0,0.2)',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[400],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 24,
    height: 24,
    borderRadius: '50%',
  },
  '& .MuiSwitch-track': {
    borderRadius: 44 / 2,
    backgroundColor: '#E9E9EA',
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border'], {
      duration: 500,
    }),
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 12px',
  },
}));

export default BasicSwitchWithStatus;
